module.exports = __webpack_public_path__ + "static/gray-b44fa5f119c9937bb7d2517f45fa8f84.png";